import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-download\">\n  <path id=\"icon-download_Path_1024\" data-name=\"Path 1024\" d=\"M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM9.71,10.29,11,11.59V6h2v5.59l1.29-1.29,1.41,1.41L12,15.41l-3.71-3.7ZM16,18H8V16h8Z\" transform=\"translate(-2 -2)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol